import React from 'react'
import queryString from 'query-string'
import { useHistory } from "react-router-dom";
import OverlayLoader from "../Components/OverlayLoader";
function NotFound() {
    const history = useHistory();
    const parsed = queryString.parse(window.location.search);
    const cks = parsed.ck;
    async function handles(ck: string[] | string | null) {
        if(ck !== '') {
            const res = await fetch(`${process.env.REACT_APP_FIND_ISN_COMPANY_URL}?ck=${ck}`, {
                method: 'GET',
            });

            const results = await res.json();

            if (results.count === 1) {
                window.location.href = `https://${results.url}`;
            }
            else if(results.count > 1)
            {
                history.push('/multiple-key');
            } else {
                history.push('/where-is-my-isn');
            }
        }
        else
        {
            history.push('/');
        }
    }

    handles(cks);

    return (
        <OverlayLoader open={true} thickness={5} size={50}/>
    );
};

export default NotFound